<template>
    <div id="app">
        <div id="mainContainer" style="height:100%;width: 100%;">
            <el-container class="heightfull">
                <el-header class="homeHeader">
                    <div class="title">博雅明德信息管理系统！</div>
                    <div>
                        <!-- <el-button icon="el-icon-bell" type="text" style="margin-right: 8px;color: #000000;" size="normal" @click="goChat"></el-button> -->
                        <el-dropdown class="userInfo" @command="commandHandler">
                        <span class="el-dropdown-link">
                            {{user.name}}<i><img :src="user.userface" alt=""></i>
                        </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="userinfo">个人中心</el-dropdown-item>
                                <el-dropdown-item command="setting">设置</el-dropdown-item>
                                <el-dropdown-item command="logout" divided>注销登录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </el-header>
                <el-container id="scorl">
                    <el-aside width="220px">
                        <el-menu router unique-opened>
                            <el-submenu :index="index+''" v-for="(item,index) in routes" v-if="!item.hidden" :key="index">
                                <template slot="title">
                                    <i style="color: #409eff;margin-right: 5px" :class="item.iconCls"></i>
                                    <span>{{item.name}}</span>
                                </template>
                                <el-menu-item :index="child.path" v-for="(child,indexj) in item.children" :key="indexj">
                                    {{child.name}}
                                </el-menu-item>
                            </el-submenu>
                        </el-menu>
                    </el-aside>
                    <el-main>
                        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="this.$router.currentRoute.path!='/home'">
                            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
                            <el-breadcrumb-item>{{this.$router.currentRoute.name}}</el-breadcrumb-item>
                        </el-breadcrumb>
                        <div class="homeWelcome" v-if="this.$router.currentRoute.path=='/home'">
                            欢迎来到博雅明德！
                        </div>
                        <router-view class="homeRouterView"/>
                    </el-main>
                </el-container>
                <el-footer>
                    <div style=" bottom: 10px;  z-index: 100; text-align: center;  ">
                        <a  href="https://beian.miit.gov.cn/" target="_blank" >津ICP备2021002884号</a>
                    </div>
                </el-footer>
            </el-container>
           
        </div>
    </div>
</template>

<script>
import router from '../router';

    export default {
    name: "Home",
    data() {
        return {
        // user: JSON.parse(window.sessionStorage.getItem("user"))
        };
    },
    mounted() {
        var browerWidth = window.innerWidth; //document.documentElement.clientWidth; //浏览器可视宽度
        var baseWidth = 1920; //设计稿宽度
        var zoomValue = browerWidth / baseWidth; //缩放比例计算
        document.getElementById("mainContainer").style.transform = "scale(" + zoomValue + "," + zoomValue + ")"; //mainContainer为主容器id
        document.getElementById("mainContainer").style.transform = "scale(1,1)";
        window.onresize = function () {
            debugger
            browerWidth = window.innerWidth;
            zoomValue = browerWidth / baseWidth;
            document.getElementById("mainContainer").style.transform = "scale(" + zoomValue + "," + zoomValue + ")";
            document.getElementById("mainContainer").style.transform = "scale(1,1)";
        };
    },
    computed: {
        routes() {
            return this.$store.state.routes;
        },
        user() {
            return this.$store.state.currentHr;
        }
    },
    methods: {
        goChat() {
            this.$router.push("/chat");
        },
        commandHandler(cmd) {
            if (cmd == 'logout') {
                this.$confirm('此操作将注销登录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.getRequest("/logout");
                    window.sessionStorage.removeItem("user");
                    this.$store.commit('initRoutes', []);
                    this.$router.replace("/");
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });
                });
            }
            else if (cmd == 'userinfo') {
                this.$router.push('/hrinfo');
            }
        }
    },
    components: { router }
}
</script>

<style>
    .homeRouterView {
        margin-top: 10px;
    }
    
    #app {
    width: 100vw;
    height: 100vh;
    background: rgb(255, 255, 255);
    display: flex;
    align-items: center;
    justify-content: center;
    }
    section #scorl {
		margin-bottom: 40px;
		height: 90%;
	}
    .heightfull{
        height: 100%;
    }
    .homeWelcome {
        text-align: center;
        font-size: 30px;
        font-family: 华文行楷;
        color: #409eff;
        padding-top: 50px;
    }

    .homeHeader {
        background-color: #409eff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 15px;
        box-sizing: border-box;
    }

    .homeHeader .title {
        font-size: 30px;
        font-family: 华文行楷;
        color: #ffffff
    }

    .homeHeader .userInfo {
        cursor: pointer;
    }

    .el-dropdown-link img {
        width: 48px;
        height: 48px;
        border-radius: 24px;
        margin-left: 8px;
    }

    .el-dropdown-link {
        display: flex;
        align-items: center;
    }
</style>